/**
 * Formats an errors response based on an error object
 * @param {object} error - Error object
 * @return {object} - Formatted error
 */
const formatErrorResponse = (error) => {
  const customError = error;
  customError.status = error.response ? error.response.status : null;

  return customError;
};

export default formatErrorResponse;
